import { convexQuery } from '@convex-dev/react-query'
import { api } from '@cvx/_generated/api'
import type { Id } from '@cvx/_generated/dataModel'
import { useQuery } from '@tanstack/react-query'

export const CandidateReferralSource = ({
  candidateId,
}: {
  candidateId: Id<'candidates'>
}) => {
  const { data: referral } = useQuery(
    convexQuery(
      api.features.candidates.referrals.getReferralSourceForCandidate,
      { candidateId },
    ),
  )

  if (!referral) return null

  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs font-medium text-primary/70">Referral source</p>
      <span className="inline-block rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">
        Referred
      </span>
      {referral.note && (
        <p className="mt-1 text-xs text-primary/60">{referral.note}</p>
      )}
    </div>
  )
}
